import CountryCodeDashboard from './Dashboard';

const Index = {
  Dashboard: CountryCodeDashboard
};

export default Index;